import React, { useState } from 'react';
import Header from '../../components/common/global-top-bar';
import RightArrow from '../../assets/images/left-arrow-symbol.svg';
import { useHistory } from 'react-router-dom';
import { useDispatch, connect } from 'react-redux';
import Spinner from '../../components/common/spinner';
import { ROUTE_PATH } from '../../routes/paths';
import Searchbar from '../../components/common/searchbar';
import {
  fetchBlackListListRequest,
  fetchBlackListCountRequest,
  postBlackListRequest,
  removeBlackListRequest,
} from './redux-tags/actions';
import { CustomInput, DropDown, Pagination } from '../../components/common';
import { Headeroptions } from './user-safety-constants';
import SwitchBar from '../../components/switch-bar';
import Modal from '../../components/common/modal';
import AlertBox from '../../components/route-leaving-prompt/alert-box';

export const blackListType = {
  'Phone Number': 'mobile_phone',
  'Email Address': 'email_address',
  'IP Address': 'ip_address',
};

type props = {
  blackList: any;
  pending: any;
  blackListCount: any;
};

type state = {
  showModal: boolean;
  resourceId: number;
  name: string;
};

type FilterProps = {
  addFunctionality: () => void;
  fetchData: (data: any) => void;
  count: number | undefined;
};

const Filters: React.FunctionComponent<FilterProps> = ({ count, fetchData, addFunctionality }): JSX.Element => {
  const [filters, setfilters] = useState({
    page: 1,
    limit: 25,
    search: '',
    entity_type: blackListType['Phone Number'],
  });

  return (
    <div className="gray-border-line bg-gray-background-light flex h-10 w-full items-center justify-between border-b px-7">
      <div className="w-1/3">
        <div className="flex h-8 w-full">
          <div className="w-3/4">
            <Searchbar
              search={(data) => {
                setfilters((prev) => {
                  return { ...prev, page: 1, search: data };
                });
                fetchData({ ...filters, page: 1, search: data });
              }}
            />
          </div>
          <button className="mx-2 h-full w-1/4 rounded-full bg-white py-1 text-center" onClick={addFunctionality}>
            ADD +
          </button>
        </div>
      </div>
      <div className="w-1/4">
        <Pagination
          pageCount={Math.ceil((count || 10) / 25)}
          key={Math.ceil((count || 10) / 25)}
          updatePageNumber={(pages) => {
            setfilters((filter) => {
              return { ...filter, page: pages + 1 };
            });
            fetchData({ ...filters, page: pages + 1 });
          }}
        />
      </div>
      <div className="w-1/3">
        <div className="flex justify-end">
          <div className="gray-background-dark flex items-center justify-between py-4">
            {Object.keys(blackListType).map((item) => (
              <button
                className={
                  'px-3 py-1 text-sm ' +
                  //@ts-ignore
                  (blackListType[item] === filters.entity_type
                    ? 'bg-blue-primary text-white'
                    : 'bg-gray-background-dark text-gray-dark')
                }
                onClick={() => {
                  setfilters((filter) => {
                    //@ts-ignore
                    return {
                      ...filter,
                      //@ts-ignore
                      entity_type: blackListType[item],
                      page: 1,
                    };
                  });
                  fetchData({
                    ...filters,
                    //@ts-ignore
                    entity_type: blackListType[item],
                    page: 1,
                  });
                }}
              >
                {/* @ts-ignore */}
                {item}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

const defaultState = {
  showModal: false,
  resourceId: 0,
  name: '',
};

const BlackList: React.FunctionComponent<props> = (props): JSX.Element => {
  const [tagType, settagType] = useState(blackListType['Phone Number']);
  const [filters, setfilters] = useState();
  const [state, setState] = useState<state>(defaultState);
  const [enablePopUp, setenablePopUp] = useState(false);
  const [Values, setValues] = useState({
    entity_type: blackListType['Phone Number'],
    value: '',
  });

  const dispatch = useDispatch();

  const fetchData = (filter: any) => {
    const { page, limit, ...rest } = filter;
    settagType(filter.entity_type.replace('_', ' '));
    setfilters(filter);
    dispatch(fetchBlackListListRequest(filter));
    dispatch(fetchBlackListCountRequest(rest));
  };

  const deleteBlackList = () => {
    dispatch(removeBlackListRequest({ id: state.resourceId, filters }));
    setState(defaultState);
  };

  return (
    <div>
      <Header heading={'Safety'} />
      <SwitchBar heading={Headeroptions} position={1} />

      <Filters
        count={props.blackListCount?.count}
        fetchData={fetchData}
        addFunctionality={() => {
          setenablePopUp(true);
        }}
      />

      <div className="max-window-height overflow-y-auto pb-10">
        <div className="w-full px-7">
          {props.pending && <Spinner />}
          <div className="text-gray-dark sticky mb-2 grid h-12 w-full grid-cols-12 items-center border-b-2 border-black text-left font-bold">
            <div className="col-span-5 font-bold">
              {/* @ts-ignore */}
              <p className="pl-10 capitalize">{tagType}</p>
            </div>
            <div className="col-span-7">Type </div>
          </div>
          <div className="w-full overflow-y-scroll">
            {props.blackList?.length > 0 ? (
              props.blackList?.map((tag: any) => (
                <div
                  className="text-gray-dark my-2 grid h-12 w-full cursor-pointer grid-cols-12 items-center rounded-xl border-y bg-gray-200 text-left"
                  onClick={() => {}}
                >
                  <div className="col-span-5 font-bold">
                    <p className="pl-10">{tag.value}</p>
                  </div>
                  <div className="col-span-7 mr-2 flex items-center justify-between">
                    <div className="col-span-3 capitalize"> {tag.entity_type.replace('_', ' ')} </div>
                    <button
                      className="bg-blue-primary rounded-md px-2 py-1 font-bold text-white"
                      onClick={() => {
                        setState({
                          showModal: true,
                          name: tag.value,
                          resourceId: tag.id,
                        });
                      }}
                      data-testid="blacklist-delete-button"
                    >
                      DELETE
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <p className="blue-primary ml-3 py-2 text-xl font-normal capitalize">No {tagType} Found</p>
            )}
          </div>
        </div>
      </div>
      <Modal
        isModel={enablePopUp}
        InnerComponent={
          <div className="z-100 fixed inset-0 flex items-center justify-center overflow-x-hidden shadow-lg outline-none focus:outline-none">
            <div className="w-162.5 max-h-162.5 relative mx-auto my-6 max-w-5xl overflow-y-auto shadow-md">
              <div className="relative flex w-full flex-col rounded-lg border-0 bg-white shadow-lg outline-none focus:outline-none">
                <div className="flex items-start justify-between">
                  <div className="blue-primary px-10 py-5 text-2xl">Add Blacklist Entry</div>
                </div>
                <div className="mb-5 w-1/2 px-7">
                  <p className="text-gray-dark float-left my-2 mb-2 block font-normal leading-4">Type</p>
                  <DropDown
                    Label={''}
                    value={Values.entity_type}
                    setValue={(data: string) => {
                      setValues((values: any) => ({
                        ...values,
                        entity_type: data,
                      }));
                    }}
                    data-testid="blacklist-type"
                  >
                    {Object.entries(blackListType).map((blacklist) => (
                      <option value={blacklist[1]}>{blacklist[0]}</option>
                    ))}
                  </DropDown>
                  <CustomInput
                    inputType={'text'}
                    value={Values.value}
                    setValue={(data: boolean) => {
                      setValues((values: any) => ({
                        ...values,
                        value: data,
                      }));
                    }}
                    Label={'value'}
                    // Error={formError?.userName}
                    // ErrorMessage={formError?.userName}
                    labelClass="font-normal"
                    dataTestId="blacklist-value"
                  />
                </div>

                <div className="flex items-center justify-center pb-6">
                  <div>
                    <button
                      className="bg-blue-primary text-cente mr-3 rounded-full px-7 py-2 text-sm text-white"
                      type="button"
                      onClick={() => {
                        dispatch(
                          postBlackListRequest({
                            payload: Values,
                            filters,
                          }),
                        );
                        setenablePopUp(false);
                      }}
                    >
                      Add
                    </button>

                    <button
                      className="bg-gray-light text-cente rounded-full px-7 py-2 text-sm text-white"
                      type="button"
                      onClick={() => {
                        setenablePopUp(false);
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      />
      <AlertBox
        visible={state.showModal}
        handlePrompt={deleteBlackList}
        closeModal={() => setState(defaultState)}
        titleText={'Alert'}
        contentText={`Are you sure you want to remove ${tagType} ${state.name}?`}
        cancelButtonText={'Cancel'}
        confirmButtonText={'Remove'}
      />
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    blackList: state.safety.BlackListList?.data || null,
    blackListCount: state.safety.BlackListCount?.data || null,
    pending: state.safety?.pending || null,
  };
};

export default connect(mapStateToProps)(BlackList);
